import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import ExaminationTable from './ExaminationTable';

const ExaminationPage = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Examinations' parent='Exam' />
      <Container fluid={true}>
        <Row>
          <ExaminationTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default ExaminationPage;
